import { c as _c } from "react/compiler-runtime";
interface CronosIconProps {
  className?: string;
}
export function CronosIcon(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fill="#002D74" d="M60.1,0L0,34.7v69.4l60.1,34.7l60-34.7V34.7L60.1,0z M102.3,93.8l-42.3,24.4L17.8,93.8V45l42.3-24.4L102.3,45 V93.8z" />;
    t2 = <path fill="#002D74" d="M60.1,138.8l60-34.7V34.7L60.1,0v20.6L102.3,45v48.9l-42.3,24.4V138.8z" />;
    t3 = <path fill="#002D74" d="M60.1,0L0,34.7v69.4l60.1,34.7v-20.5L17.8,93.8V45l42.3-24.4V0z" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.1 138.8" className={className}>{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}